<div class="no-conversation-container">
  <p-card class="axede-metrics-card axede-slide-up" [style]="{'overflow': 'hidden'}">
    <ng-template pTemplate="title">
      <div class="metrics-card-header">
        <i class="pi pi-comments" aria-hidden="true"></i>
        <h2>{{ 'agent.metrics.title' | translate }}</h2>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="metrics-content">
        <p class="no-conversation-message">{{ 'agent.metrics.noConversation' | translate }}</p>
        <p class="metrics-subtitle">{{ 'agent.metrics.subtitle' | translate }}</p>

        <div class="metrics-placeholder">
          <div class="metrics-icon" [attr.aria-label]="'agent.metrics.iconBarChart' | translate">
            <i class="pi pi-chart-bar" aria-hidden="true"></i>
          </div>
          <div class="metrics-icon" [attr.aria-label]="'agent.metrics.iconLineChart' | translate">
            <i class="pi pi-chart-line" aria-hidden="true"></i>
          </div>
          <div class="metrics-icon" [attr.aria-label]="'agent.metrics.iconUsers' | translate">
            <i class="pi pi-users" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button
        pButton type="button"
        [label]="'agent.metrics.viewMyMetrics' | translate"
        icon="pi pi-chart-line"
        class="metrics-button"
        [attr.aria-label]="'agent.metrics.viewMyMetricsAria' | translate"
      >
      </button>
<!--      <button-->
<!--        pButton type="button"-->
<!--        label="Ver mis métricas"-->
<!--        icon="pi pi-chart-line"-->
<!--        class="metrics-button"-->
<!--        (click)="goToMetrics()"-->
<!--        aria-label="Navegar a la página de métricas detalladas del agente"-->
<!--      >-->
<!--      </button>-->
    </ng-template>
  </p-card>
</div>
